import { Routes, Route } from "react-router-dom";
import CountriesList from './CountriesList';

export default function CountriesPage() {
    return (
        <Routes>
            <Route path="/" element={<CountriesList />}/>
        </Routes>
    )
}